import { snakeCase } from 'lodash';

/**
 * NOTE: It works shallowly.
 *
 * @param {Object} target - object to transform keys of.
 *
 * @return {Object} - returns object with snake cased keys on top level.
 */
export const toSnakeCase = target =>
  Object.entries(target).reduce((acc, [key, value]) => ({
    ...acc,
    [snakeCase(key)]: value,
  }), {});
